import React from 'react';
import { ErrorReportingCollapsiblePanel } from './ErrorReportingCollapsiblePanel';
import { Modal, Paragraph } from '@unifocus/react-components';
import { ErrorDetails, formatMessageBundle } from '@unifocus/js-utils';
import messages from '../localized-messages';

export interface ErrorReportingModalProperties {
   visible: boolean;
   errorDetails: ErrorDetails;
   cancelIconTapHandler: () => void;
   errorReportCancelHandler: () => void;
   errorReportSendHandler: () => void;
}

export const ErrorReportingModal = (props: ErrorReportingModalProperties) => {
   const dontSendButtonText: string = formatMessageBundle(messages, 'res_dontSend');
   const sendErrorReportButtonText: string = formatMessageBundle(messages, 'res_sendErrorReport');
   const title: string = formatMessageBundle(messages, 'res_anErrorHasOccurred');
   const errorMessageLineOne: string = formatMessageBundle(messages,
                                                           'res_anErrorOccurredMessageLineOne');
   const errorMessageLineTwo: string = formatMessageBundle(messages,
                                                           'res_anErrorOccurredMessageLineTwo');

   return (
      <Modal
         title={title}
         visible={props.visible}
         onCancel={props.cancelIconTapHandler}
         buttons={[
            {
               text: dontSendButtonText,
               onClick: props.errorReportCancelHandler
            },
            {
               text: sendErrorReportButtonText,
               type: 'primary',
               onClick: props.errorReportSendHandler
            }
         ]}
      >
         <Paragraph
            className="uf-error-reporting-modal-message"
         >
            {errorMessageLineOne}
         </Paragraph>
         <Paragraph
            className="uf-error-reporting-modal-message"
         >
            {errorMessageLineTwo}
         </Paragraph>
         <ErrorReportingCollapsiblePanel
            errorDetails={props.errorDetails}
         />
      </Modal>
   );
};
